import {Row, Col, Card, Table, Button, Modal, Input, Tag, Tooltip} from "antd";
import React, {useState, useEffect, useRef} from "react";
import useRequest from "../../hooks/useRequest";
import {useSearchParams} from "react-router-dom";
import {ShowToast, Severty} from "../../helper/toast";
import Main from "../../components/layout/Main";
import useDebounce from "../../hooks/useDebounce";
import {ExclamationCircleOutlined} from '@ant-design/icons';
import {useNavigate} from "react-router";
import apiPath from "../../constants/apiPath";
import ShowTotal from "../../components/ShowTotal";
import moment from 'moment';
import {PRICE} from "../../constants/conts";
import {Link} from "react-router-dom";

const Search = Input.Search;

function Index() {

    const [searchParams] = useSearchParams();
    const [searchText, setSearchText] = useState('');
    const {request} = useRequest()
    const [list, setList] = useState([])
    const [loading, setLoading] = useState(false)
    const [refresh, setRefresh] = useState(false)
    const [pagination, setPagination] = useState({current: 1, pageSize: 10});
    const debouncedSearchText = useDebounce(searchText, 300);
    const {confirm} = Modal;
    const navigate = useNavigate();


    const showConfirm = (record) => {
        setTimeout(() => {
            confirm({
                icon: <ExclamationCircleOutlined/>,
                content: <Button>Are you sure you want change the status ?</Button>,
                onOk() {
                    statusChange(record)
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        }, 5);

    };

    const view = (record) => {
        navigate(`/subscription/view/${record._id}`)
    }

    const edit = (record) => {
        navigate(`/subscription/update/${record._id}`)
    }

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            render: (_, {name, _id}) => {
                if (name) {
                    return <Link className="cap" to={`/subscription/view/${_id}`}>{name}</Link>;
                } else {
                    return '-';
                }
            },
        },
        {
            title: "Car Type",
            dataIndex: "car_type", // You can remove this or keep it; it’s not used if `render` is defined
            key: "type_id",
            render: (_, record) => {
                let result = '';
                for (const resultElement of record.type_id) {
                    result += resultElement.name ;
                }
return result;
            },
        },
        {
            title: "Price (" + PRICE + ")",
            dataIndex: "price",
            key: "price",
        },
        {
            title: "Discount (" + PRICE + ")",
            dataIndex: "discount",
            key: "discount",
        },
        {
            title: "NO. of time",
            dataIndex: "no_of_time",
            key: "no_of_time",

        }, {
            title: "NO. of day",
            dataIndex: "no_of_day",
            key: "no_of_day",

        }, {
            title: "From Date",
            dataIndex: "from_date",
            key: "from_date",
            render: (_, {from_date}) => {
                return (from_date ? from_date : '-')
            },
        },
        {
            title: "To Date",
            dataIndex: "to_date",
            key: "to_date",
            render: (_, {to_date}) => {
                return (to_date ? to_date : '-')
            },
        },
        {
            title: "Status",
            key: "is_active",
            filters: [
                {
                    text: 'Active',
                    value: true,
                },
                {
                    text: 'Inactive',
                    value: false,
                },
            ],
            render: (_, {is_active, _id}) => {
                let color = is_active ? 'green' : 'red';
                return (<a><Tag onClick={(e) => showConfirm(_id)} color={color}
                                key={is_active}>{is_active ? "Active" : "Inactive"}</Tag></a>);
            },
        },
        {
            title: "Created On",
            key: "created_at",
            dataIndex: "created_at",
            render: (_, {created_at}) => {
                return (
                    moment(created_at).format('DD-MM-YYYY')
                );
            },
        },
        {
            title: "Action",
            fixed: 'right',
            render: (_, record) => {
                return (
                    <>
                        <Tooltip title="Update Subscription" color={"purple"} key={"updatesubscription"}><Button
                            title="Edit" onClick={() => {
                            edit(record)
                        }}><i className="fa fa-light fa-pen"></i></Button></Tooltip>
                        <Tooltip title="View Subscription" color={"purple"} key={"viewsubscription"}><Button
                            title="View Subscription" onClick={() => {
                            view(record)
                        }}><i className="fa fa-light fa-eye"></i></Button></Tooltip>
                    </>
                );
            },
        },
    ];


    const statusChange = (record) => {
        setLoading(true);
        request({
            url: apiPath.statusSubscription + "/" + record,
            method: 'GET',
            onSuccess: (data) => {
                setRefresh(prev => !prev)
                setLoading(false);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    };


    useEffect(() => {
        setLoading(true)
        fetchData(pagination)
    }, [refresh, debouncedSearchText])


    const fetchData = (pagination, filters) => {
        const filterActive = filters ? filters.is_active : null

        request({
            url: apiPath.listSubscription + `?query_string=${searchParams.get('query')}&status=${filterActive ? filterActive.join(',') : ''}&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10}&search=${debouncedSearchText}`,
            method: 'GET',
            onSuccess: (data) => {
                setLoading(false)
                setList(data.data.list.docs)
                setPagination(prev => ({current: pagination.current, total: data.data.list.totalDocs}))
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    const handleChange = (pagination, filters) => {
        console.log(pagination, filters);
        fetchData(pagination, filters);
    }

    const onSearch = (e) => {
        setSearchText(e.target.value)
        setPagination({current: 1})
    };

    return (
        <Main>
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Subscription Management"
                            extra={
                                <>
                                    <Search
                                        size="large"
                                        onChange={onSearch}
                                        onPressEnter={onSearch}
                                        value={searchText}
                                        placeholder="Search By Name"
                                    />
                                    <Link className="ant-btn ant-btn-default" to="/subscription/add/">Add
                                        Subscription</Link>
                                </>
                            }
                        >

                            <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
                            <div className="table-responsive customPagination">
                                <Table
                                    loading={loading}
                                    columns={columns}
                                    dataSource={list}
                                    pagination={{
                                        defaultPageSize: 10,
                                        responsive: true,
                                        total: pagination.total,
                                        showSizeChanger: true,
                                        showQuickJumper: true,
                                        pageSizeOptions: ['10', '20', '30', '50']
                                    }}
                                    onChange={handleChange}
                                    className="ant-border-space"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </Main>
    );
}

export default Index;
